import { useUrlFilters } from "@racoon/ui";

/** How the shift registry groups its shifts: one card per truck or one per driver. */
export type ShiftsView = "truck" | "driver";

/**
 * What differs between the views besides the grouping itself. Each keeps its own
 * saved column layout (the layouts carry column order, and the column sets differ),
 * and each hides the columns its group header already answers.
 */
export const SHIFT_VIEWS: Record<
  ShiftsView,
  { settingsTable: string; hiddenColumns: ReadonlySet<string> }
> = {
  // The header names the truck, so rows name the driver.
  truck: { settingsTable: "shifts", hiddenColumns: new Set(["plateNumber", "model", "type"]) },
  // The header names the driver, so rows name the truck.
  driver: { settingsTable: "shifts_by_driver", hiddenColumns: new Set(["driverName"]) },
};

/** The registry's view, kept in `?view=` so a link or a refresh reopens it. */
export const useShiftsView = () => {
  const { sp, patch } = useUrlFilters();
  // Anything but an explicit `driver` — no param, a stale or mistyped value — is the truck view.
  const view: ShiftsView = sp.get("view") === "driver" ? "driver" : "truck";
  const setView = (next: ShiftsView) => patch({ view: next === "driver" ? next : null });

  return { view, setView };
};
